import React, { useEffect, useState } from "react";
import { Project_Type } from "../model";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import Loading from "../components/Loading";
import Video from "../components/Video";

const Projects: React.FC = () => {
  const [projects, setProjects] = useState<Project_Type[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    onSnapshot(
      collection(db, "projects"),
      (snapshot) => {
        setProjects(snapshot.docs.map((doc) => doc.data() as Project_Type));
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);

  return (
    <div className="container mx-auto py-8">
      <h1 className="text-4xl font-bold mb-8">
        Projects{" "}
        <sup className="text-gray-500 text-sm font-normal">
          {projects.length} and more projetcs
        </sup>
      </h1>
      {loading && !projects.length && <Loading />}
      <div className="mx-4 sm:mx-0 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {projects.map((project, index) => (
          <div
            key={index}
            className="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl duration-300 transition-all ease-in-out"
          >
            <Video url={project.video} />
            <div className="felx flex-col p-4">
              <h2 className="text-xl font-bold mb-2">{project.title}</h2>
              <span>
                <p className="text-gray-700 flex-1">{project.description}</p>
                <a
                  href={project.link}
                  className="mt-4 inline-block px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors duration-300"
                >
                  View Project
                </a>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
